const PREFIX = 'flowy_';

export const storage = {
    setItem: (key: string, value: string) => {
        localStorage.setItem(`${PREFIX}${key}`, value);
    },

    getItem: (key: string): string | null => {
        return localStorage.getItem(`${PREFIX}${key}`);
    },

    removeItem: (key: string) => {
        localStorage.removeItem(`${PREFIX}${key}`);
    },

    clear: () => {
        const keysToRemove: string[] = [];
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && key.startsWith(PREFIX)) {
                keysToRemove.push(key);
            }
        }
        keysToRemove.forEach(key => localStorage.removeItem(key));
    },

    key: (index: number): string | null => {
        const key = localStorage.key(index);
        if (key && key.startsWith(PREFIX)) {
            return key.substring(PREFIX.length);
        }
        return null;
    },

    get length(): number {
        let count = 0;
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && key.startsWith(PREFIX)) {
                count++;
            }
        }
        return count;
    }
};
